import { PlaylistSettingsMessage } from "../types";

export const defaultPlaylistSettings: PlaylistSettingsMessage = {
  licenseKey: "",
  playerScript: "",
  playlistUrl: ""
};

export const defaultTitle = "Tips & Picks";
